import React, { Component } from 'react'

import ManualSelectionAddress from './ManualSelectionAddress'
import AutoSelectionAddress from './AutoSelectionAddress'
import { isEmpty } from '../../libs/validation/stringRegex'


interface InputProps {
    value: string | undefined      // il valore -- INDIRIZZO

    street: string | undefined
    number: string | undefined
    zip: string | undefined
    city: string | undefined

    error: string | undefined       // erore sul indirizzo (nella sua totalita)

    streetError: string | undefined
    numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined

    updateAll: Function 
    updateStreet: Function
    updateNumber: Function
    updateZip: Function
    updateCity: Function
    
    clearError?: Function
    
    clearStreetError?: Function
    clearNumberError?: Function
    clearZipError?: Function
    clearCityError?: Function

    expiredSessionCallbak?: Function

    is_manual_address?: boolean
    updateManualSelectionCallBack?: Function    // salva la scelta tra inserimento manuale o autocompletamento del utente

    isSedeLegale?: boolean | undefined

    id?: string
    label?: string
}

interface InputState {
    showManual: boolean
}


class AddressInput extends Component<InputProps, InputState> {

    constructor (pros: any) {
        super (pros)

        this.state = {
            showManual: (this.props.is_manual_address !== undefined) ? this.props.is_manual_address : false
        }

        this.toggleShowManual = this.toggleShowManual.bind(this)
        this.clearError = this.clearError.bind(this)
        this.clearStreetError = this.clearStreetError.bind(this)
        this.clearNumberError = this.clearNumberError.bind(this)
        this.clearZipError = this.clearZipError.bind(this)
        this.clearCityError = this.clearCityError.bind(this)
    }

    componentDidMount(): void {
        this.props.updateManualSelectionCallBack && this.props.updateManualSelectionCallBack( this.state.showManual === true )
    }

    componentDidUpdate(prevProps: Readonly<InputProps>, prevState: Readonly<InputState>, snapshot?: any): void {
        if (
            this.props.is_manual_address !== undefined &&
            this.props.is_manual_address !== prevProps.is_manual_address &&
            this.props.is_manual_address !== this.state.showManual &&
            this.props.is_manual_address !== prevState.showManual
        ) {
            this.setState({
                showManual: this.props.is_manual_address
            })
        }
    }

    render(): React.ReactNode {
        const id = this.props.id ?? ((this.props.isSedeLegale === true)
            ? 'indirizzoResidenza_auto'
            : 'indirizzoSedeLegale_auto')

        const label = this.props.label ?? ((this.props.isSedeLegale === true)
            ? 'Cerca l\'indirizzo della sede legale'
            : 'Cerca l\'indirizzo di residenza')

        // riposiziono gli errori per la compilazione manuale --> ordine diverso dei campi
        let manual_cityError = undefined
        let manual_zipError = undefined
        let manual_streetError = undefined
        let manual_numberError = undefined

        if (this.props.error !== undefined) {
            if (this.props.cityError === undefined && isEmpty(this.props.city)) {
                manual_cityError = this.props.error
            }
            else if (this.props.zipError === undefined && isEmpty(this.props.zip)) {
                manual_zipError = this.props.error
            }
            else if (this.props.streetError === undefined && isEmpty(this.props.street)) {
                manual_streetError = this.props.error
            }
            else if (this.props.numberError === undefined && isEmpty(this.props.number)) {
                manual_numberError = this.props.error
            }
        }

        return (
            <>
                {!this.state.showManual &&
                    <>
                        <AutoSelectionAddress 
                            id={id} name={id}
                            label={label}

                            value={this.props.value}

                            street={this.props.street}
                            number={this.props.number}
                            zip={this.props.zip}
                            city={this.props.city}

                            error={this.props.error}
                            streetError={this.props.streetError}
                            numberError={this.props.numberError}
                            zipError={this.props.zipError}
                            cityError={this.props.cityError}
                            
                            callback={this.props.updateAll}
                            updateNumber={this.props.updateNumber}

                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                            onFocus={this.clearError}
                        />
                        <div className='col-12 text-end'>
                            <span
                                className='address_toggler toggler'
                                onClick={this.toggleShowManual}
                            >
                                Compilazione manuale
                            </span>
                        </div>
                    </>
                }
                {this.state.showManual && 
                    <>
                        <ManualSelectionAddress 
                            street={this.props.street}
                            number={this.props.number}
                            zip={this.props.zip}
                            city={this.props.city}

                            cityError={manual_cityError}
                            zipError={manual_zipError}
                            streetError={manual_streetError}
                            numberError={manual_numberError}

                            updateStreet={this.props.updateStreet}
                            updateNumber={this.props.updateNumber}
                            updateZip={this.props.updateZip}
                            updateCity={this.props.updateCity}
                            error={this.props.error}

                            clearStreetError={this.props.clearStreetError}
                            clearNumberError={this.props.clearNumberError}
                            clearZipError={this.props.clearZipError}
                            clearCityError={this.props.clearCityError}

                            expiredSessionCallbak={this.props.expiredSessionCallbak}

                            isSedeLegale={this.props.isSedeLegale}
                        />
                        <div className='col-12 text-end'>
                            <span
                                className='address_toggler toggler'
                                onClick={this.toggleShowManual}
                            >
                                Ricerca indirizzo
                            </span>
                        </div>
                    </>
                }
            </>
        )
    }

    private toggleShowManual () {
        this.setState({
            showManual: !this.state.showManual
        }, () => {
            this.props.updateManualSelectionCallBack && this.props.updateManualSelectionCallBack( this.state.showManual === true )
            this.clearError()
            this.clearStreetError()
            this.clearNumberError()
            this.clearZipError()
            this.clearCityError()
        })
    }


    private clearError () {
        if (this.props.clearError) {
            this.props.clearError()
        }
    }
    private clearStreetError () {
        if (this.props.clearStreetError) {
            this.props.clearStreetError()
        }
    }
    private clearNumberError () {
        if (this.props.clearNumberError) {
            this.props.clearNumberError()
        }
    }
    private clearZipError () {
        if (this.props.clearZipError) {
            this.props.clearZipError()
        }
    }
    private clearCityError () {
        if (this.props.clearCityError) {
            this.props.clearCityError()
        }
    }
}

export default AddressInput